import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/operacaoTotalizadorVeiculo/actions';

import Form from './form';

function OperacaoTotalizadorVeiculo() {
  const redux = useSelector((state) => state.operacaoTotalizadorVeiculo);

  // Totalizador
  const totalizer = useMemo(
    () => [
      { label: 1, value: t('s.operacao.abastecimento.horimetro') },
      { label: 2, value: t('s.operacao.abastecimento.hodometro') },
    ],
    []
  );

  const totalizer2 = useMemo(
    () => [
      { label: 0, value: 'Não Possui' },
      { label: 1, value: t('s.operacao.abastecimento.horimetro') },
      { label: 2, value: t('s.operacao.abastecimento.hodometro') },
    ],
    []
  );

  // Situação do veículo
  const situation = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.cadastro.veiculo.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.veiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
      // {
      //   id: 'tipototalizadorveiculo',
      //   label: t('s.cadastro.veiculo.tipototalizadorveiculo'),
      //   formatted: (value) =>
      //     totalizer.find((tot) => tot.label === value).value || '',
      //   filter: { type: 'select', options: totalizer },
      // },
      {
        id: 'tipototalizadorveiculo',
        label: t('s.cadastro.veiculo.tipototalizadorveiculo'),
        formatted: (value) => {
          const item = totalizer.find((tot) => tot.label === value);
          return item ? item.value : '';
        },
        filter: { type: 'select', options: totalizer },
      },
      {
        id: 'totalizadorveiculo',
        label: t('s.cadastro.veiculo.totalizadorveiculo'),
        filter: { type: 'text' },
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'tipototalizador2veiculo',
        label: t('s.cadastro.veiculo.tipototalizador2veiculo'),
        formatted: (value) =>
          totalizer2.find((tot) => tot.label === value).value || '',
        filter: { type: 'select', options: totalizer2 },
      },
      {
        id: 'totalizador2veiculo',
        label: t('s.cadastro.veiculo.totalizador2veiculo'),
        align: 'right',
        formatted: (value) => number(value, 1),
        filter: { type: 'text' },
      },
      {
        id: 'statusveiculo',
        label: t('s.cadastro.veiculo.statusveiculo'),
        formatted: (value) =>
          situation.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: situation },
      },
    ],
    [totalizer, situation, totalizer2]
  );

  const fieldlist = [
    'idveiculo',
    'placaveiculo',
    'nomeempresaveiculo',
    'tipototalizadorveiculo',
    'totalizadorveiculo',
    'tipototalizador2veiculo',
    'totalizador2veiculo',
    'statusveiculo',
  ];

  const substituirHeader = {
    idveiculo: t('s.cadastro.veiculo.idveiculo'),
    placaveiculo: t('s.cadastro.veiculo.placaveiculo'),
    nomeempresaveiculo: t('s.cadastro.veiculo.nomeempresaveiculo'),
    tipototalizadorveiculo: t('s.cadastro.veiculo.tipototalizadorveiculo'),
    totalizadorveiculo: t('s.cadastro.veiculo.totalizadorveiculo'),
    tipototalizador2veiculo: t('s.cadastro.veiculo.tipototalizador2veiculo'),
    totalizador2veiculo: t('s.cadastro.veiculo.totalizador2veiculo'),
    statusveiculo: t('s.cadastro.veiculo.statusveiculo'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idveiculo"
      detach="nomeveiculo"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'veiculos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Totalizador Veículos',
          substituirValores: {
            statusveiculo: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
            tipototalizadorveiculo: {
              '1': t('s.operacao.abastecimento.horimetro'),
              '2': t('s.operacao.abastecimento.hodometro'),
              '0': 'Não Possui',
            },
            tipototalizador2veiculo: {
              '0': 'Não Possui',
              '1': t('s.operacao.abastecimento.horimetro'),
              '2': t('s.operacao.abastecimento.hodometro'),
            },
          },
        })
      }
    />
  );
}

export default OperacaoTotalizadorVeiculo;
